import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c65f49e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CartAlert_Content" }
const _hoisted_2 = { class: "CartAlert_Main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "bold",
  style: {"white-space":"pre-wrap"}
}, " 「在庫ステータス/34.絶版」「断裁/4:全量廃棄」の商品が含まれています。 ", -1))
const _hoisted_4 = { class: "CartAlert_TableContainer" }
const _hoisted_5 = { class: "CartAlert_Table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "CartAlert_Table_SyosiCd" }, [
      /*#__PURE__*/_createElementVNode("p", null, "書誌CD"),
      /*#__PURE__*/_createElementVNode("p", null, "出版社書誌CD"),
      /*#__PURE__*/_createElementVNode("p", null, "ISBN13桁")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "書誌名"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createElementVNode("p", null, "在庫ST"),
      /*#__PURE__*/_createElementVNode("p", null, "断裁")
    ])
  ])
], -1))
const _hoisted_7 = { class: "delimiter text_left" }
const _hoisted_8 = { class: "text_left" }
const _hoisted_9 = { class: "delimiter zaiko_info" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "bold",
  style: {"white-space":"pre-wrap"}
}, " 該当の商品を除外しますか？ ", -1))
const _hoisted_11 = { class: "CartAlert_BtnBlock" }

import { PropType } from "vue";
import BtnGreen from "../atoms/button/BtnGreen.vue";
import { NormalCartItem } from "@/types/zaiko";
import { MultiOrderList } from "@/views/OrderFormMulti.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCartAlert',
  props: {
  zeppanItems: { type: Array as PropType<NormalCartItem[] | MultiOrderList[]> },
  isTandoku: { type: Boolean },
  tandokuSyosiInfo: { type: Object as PropType<NormalCartItem> },
},
  emits: ["close", "execute"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

const closeModal = () => {
  emit("close");
};
const execute = (isConfirm: boolean) => {
  emit("execute", isConfirm, props.isTandoku, props.tandokuSyosiInfo);
  closeModal();
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "CartAlert",
      onClick: closeModal
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'exclamation-triangle'],
          class: "icon__save__filed"
        }),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.zeppanItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.janCd
                }, [
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(item.syosiCd), 1),
                    _createElementVNode("span", null, _toDisplayString(item.syuppanSyosiCd), 1),
                    _createElementVNode("span", null, _toDisplayString(item.janCd), 1)
                  ]),
                  _createElementVNode("td", _hoisted_8, _toDisplayString("title" in item ? item.title : item.syosiMei), 1),
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("span", {
                      class: _normalizeClass({ text_red: item.zsId === '34' })
                    }, _toDisplayString(item.zsName), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass({ text_red: item.cutting === '4:全量廃棄' })
                    }, _toDisplayString(item.cutting), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(BtnGreen, {
            class: "btn_gray",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("キャンセル")
            ]),
            _: 1
          }),
          _createVNode(BtnGreen, {
            class: "btn_blue",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (execute(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("いいえ")
            ]),
            _: 1
          }),
          _createVNode(BtnGreen, {
            class: "btn_red",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (execute(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("はい")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})